import React from 'react'
import PropTypes from 'prop-types'

const styles = {
  youtubeWrapper: { width: '100%' },
}

class Youtube extends React.PureComponent {
  render() {
    const { video, autoplay = 0, rel = 0, modest = 1 } = this.props
    const link = `${video}?autoplay=${autoplay}&rel=${rel}&modestbranding=${modest}`

    return (
      <div
        className='embed-responsive embed-responsive-16by9 video-style'
        style={styles.youtubeWrapper}
      >
        <iframe className='embed-responsive-item' src={link} allowFullScreen frameBorder='0' />
      </div>
    )
  }
}

Youtube.propTypes = {
  video: PropTypes.string.isRequired,
  autoplay: PropTypes.number,
  rel: PropTypes.string,
  modest: PropTypes.string,
}
export default Youtube
